
define('ldsh!modules/lp_info/templates/page_line', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<label for="">\n  <span data-value="' +
((__t = ( id )) == null ? '' : __t) +
'" class="ed-radioTxt js-pages-list-item">' +
((__t = ( name )) == null ? '' : __t) +
'</span>\n</label>\n';

}
return __p
};});

